import styled from 'styled-components'

export const Container = styled.div<{ $width: string; $height: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  padding: 10px;
`

export const InnerContainer = styled.div<{ $bgImage: string; $layoutWidth: number }>`
  width: 100%;
  height: 100%;
  background-color: rgb(237, 238, 240);
  box-shadow: rgb(170, 170, 170) 0 0 4px 0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 5px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ${({ $layoutWidth }) => {
    if ($layoutWidth > 500) return '375px'
    return '90%'
  }};
  background-image: url(${(props) => props.$bgImage});
`
